'use strict';

var _shaderTools = require('../shader-tools');

var _fp = require('./fp64');

var fp64 = _interopRequireWildcard(_fp);

var _fog = require('./fog');

var fog = _interopRequireWildcard(_fog);

var _picking = require('./picking');

var picking = _interopRequireWildcard(_picking);

var _material = require('./material');

var material = _interopRequireWildcard(_material);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

(0, _shaderTools.registerShaderModules)([fp64, fog, picking,
// lighting,
material]);
// import * as lighting from './lighting';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVyLW1vZHVsZXMvaW5kZXguanMiXSwibmFtZXMiOlsiZnA2NCIsImZvZyIsInBpY2tpbmciLCJtYXRlcmlhbCJdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7QUFFQTs7SUFBWUEsSTs7QUFFWjs7SUFBWUMsRzs7QUFDWjs7SUFBWUMsTzs7QUFFWjs7SUFBWUMsUTs7OztBQUVaLHdDQUFzQixDQUNwQkgsSUFEb0IsRUFFcEJDLEdBRm9CLEVBR3BCQyxPQUhvQjtBQUlwQjtBQUNBQyxRQUxvQixDQUF0QjtBQUhBIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtyZWdpc3RlclNoYWRlck1vZHVsZXN9IGZyb20gJy4uL3NoYWRlci10b29scyc7XG5cbmltcG9ydCAqIGFzIGZwNjQgZnJvbSAnLi9mcDY0JztcblxuaW1wb3J0ICogYXMgZm9nIGZyb20gJy4vZm9nJztcbmltcG9ydCAqIGFzIHBpY2tpbmcgZnJvbSAnLi9waWNraW5nJztcbi8vIGltcG9ydCAqIGFzIGxpZ2h0aW5nIGZyb20gJy4vbGlnaHRpbmcnO1xuaW1wb3J0ICogYXMgbWF0ZXJpYWwgZnJvbSAnLi9tYXRlcmlhbCc7XG5cbnJlZ2lzdGVyU2hhZGVyTW9kdWxlcyhbXG4gIGZwNjQsXG4gIGZvZyxcbiAgcGlja2luZyxcbiAgLy8gbGlnaHRpbmcsXG4gIG1hdGVyaWFsXG5dKTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/react-vis/~/luma.gl/dist/experimental/shader-modules/index.js
// module id = 759
// module chunks = 0